import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { Row } from "@rui/Stack";

export const Container = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  paddingBottom: theme.spacing(6),
  flex: 1,
  maxWidth: "100%",
  [theme.breakpoints.up("sm")]: {
    padding: "40px 60px",
  },
}));

export const SwitchLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.h3,
  fontWeight: 500,
  color: theme.palette.shades.neutral[500],
  "&.active": {
    color: theme.palette.shades.primary[500],
  },
}));

export const PlanDetailRow = styled(Row)({
  justifyContent: "center",
  alignSelf: "flex-end",
  flexWrap: "wrap",
});
